export const isUrlValid = (url?: string): boolean => {
  if (!url?.length) {
    return false
  }
  const expression =
    /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi
  const regexp = new RegExp(expression)
  return regexp.test(url)
}
